import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useUnitConnectorColors } from '../../../hooks/useUnitConnectorColors';
import targetIconUrl from '../../../assets/target.svg';

interface Props {
  type: DashboardConnectorType;
  index: number;
}

export const PathSkillBadge: FC<Props> = ({ type, index }) => {
  const connectorColors = useUnitConnectorColors();
  const isLocked = type === 'locked';
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="200"
      height="65"
      viewBox="0 0 229 85"
      fill="none"
      style={{ opacity: 1 }}
    >
      <path
        d="M114.062 2C146.277 2 191.165 11.5494 215.801 17.4492C224.002 19.4136 228.339 28.2797 224.986 36.1016L208.714 74.0693C205.61 81.3109 197.022 84.7574 189.427 82.0732C172.67 76.1511 144.158 68 114.062 68C83.967 68 55.4547 76.1511 38.6982 82.0732C31.1033 84.7574 22.5147 81.3109 19.4111 74.0693L3.13867 36.1016C-0.213577 28.2797 4.12281 19.4136 12.3242 17.4492C36.9603 11.5494 81.8483 2 114.062 2Z"
        className={isLocked ? undefined : `${connectorColors.fillAccent} ${connectorColors.strokeBase}`}
        fill={isLocked ? '#F7F3F0' : undefined}
        stroke={isLocked ? '#cfcfcf' : undefined}
        strokeWidth="4"
      />

      {/* Small target icon centered above the single-line label. */}
      <image href={targetIconUrl} x="101" y="12" width="26" height="26" opacity={isLocked ? 0.6 : 1} />

      <text
        x="114"
        y="54"
        textAnchor="middle"
        fontFamily="Arial, sans-serif"
        fontSize="15"
        fontWeight="bold"
        fill={isLocked ? '#BAAF9F' : 'white'}
      >
        Path to target {index}
      </text>
    </svg>
  );
};
